<template>
  <div>
    <b-tabs
      vertical
      content-class="col-12 col-md-9 mt-1 mt-md-0"
      pills
      nav-wrapper-class="col-md-3 col-12"
      nav-class="nav-left"
    >
      <!-- profile information settings tab -->
      <b-tab
        :active="tab === 'profile' || typeof tab === undefined"
        @click="pushTab('profile')"
      >

        <!-- title -->
        <template #title>
          <span class="font-weight-bold">
            {{ $t('navigation.settings.company-profile') }}
          </span>
        </template>

        <company-details-settings-tab />
      </b-tab>
      <!--/ profile information settings tab -->

      <!-- notification settings tab -->
      <b-tab
        :active="tab === 'notifications'"
        @click="pushTab('notifications')"
      >

        <!-- title -->
        <template #title>
          <span class="font-weight-bold">
            {{ $t('navigation.settings.notifications.title') }}
          </span>
        </template>

        <notification-settings-tab />
      </b-tab>
      <!--/ notification settings tab -->

      <!-- default settings tab -->
      <b-tab
        :active="tab === 'default-settings'"
        @click="pushTab('default-settings')"
      >

        <!-- title -->
        <template #title>
          <span class="font-weight-bold">
            {{ $t('navigation.settings.default-settings') }}
          </span>
        </template>

        <default-settings-settings-tab />
      </b-tab>
      <!--/ default settings tab -->
    </b-tabs>
  </div>
</template>

<script>
import CompanyDetailsSettingsTab from '@/views/organization/settings/account/tabs/CompanyDetailsSettingsTab'
import DefaultSettingsSettingsTab from '@/views/organization/settings/account/tabs/DefaultSettingsSettingsTab'
import NotificationSettingsTab from '@/views/organization/settings/account/tabs/NotificationSettingsTab'
import accountSettingsSetup from '@/views/organization/settings/account/accountSettingsSetup'

export default {
  components: { CompanyDetailsSettingsTab, DefaultSettingsSettingsTab, NotificationSettingsTab },
  setup: accountSettingsSetup,
}
</script>

<style scoped>

</style>
